import { Injectable } from '@angular/core';
import { VersionInfo } from '../interfaces/version.info.interface';

declare global {
    interface Window {
        APP_VERSION_INFO?: VersionInfo;
    }
}

@Injectable({
    providedIn: 'root'
})
export class VersionService {

    constructor() {
    }

    public getVersionInfo(): VersionInfo {
        // Try to get version info from global variable injected during build
        if (window.APP_VERSION_INFO) {
            return window.APP_VERSION_INFO;
        }

        // Fallback version info if not available
        return {
            buildTimestamp: new Date().toISOString(),
            version: 'Dev',
            gitBranch: 'local',
            gitHash: 'unknown'
        };
    }

    public getFormattedVersionInfo(): string {
        const info = this.getVersionInfo();
        return [
            `Build: ${info.buildTimestamp}`,
            `Version: ${info.version}`,
            `Branch: ${info.gitBranch}`,
            `Hash: ${info.gitHash.substring(0, 8)}`
        ].join('\n');
    }
}